import React, { useState, useContext, useEffect } from "react";
import { Grid, Tabs, Tab, Box, Typography, useTheme, useMediaQuery, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';
import MyPath from "./Components/MyPath";
import { getStudentInfo, getStudentProfile } from "../../Utils/apiService";
import { getUserDetails } from "../../storageService";
import KenLoader from "../../GlobalComponents/KenLoader";
import { useLocation } from "react-router-dom";
import MyStudentTabPanel from "../MyStudentsFaculty/MyStudentProfile/MyStudentTabPanel";

const useStyles = makeStyles(() => ({
    resourceButton: {
        borderRadius: '8px',
        width: '300px',
        height: '75px',
        backgroundColor: " #EAEFFF !important",
        border: "none !important",
        padding: '10px 0px 10px 0px !important'
    },

    dividerresact: {
        width: "1px",
        height: "90%",
        background: "#E5E6EA",
        margin: "0 16px",
        marginRight: '2px'

    },
    tabline: {
        width: "auto",
        height: "1px",
        background: "#E5E6EA",
        margin: "16 0px",
        marginRight: '2px'

    },
    userName: {
        fontWeight: '600 ! important',
        fontSize: "20px",
        color: 'black',
        textAlign: 'left'

    },
    userId: {
        fontSize: "20px",
        color: "#373A45",
        fontWeight: '400 ! important',
        textAlign: 'left'
    },
    programTitle: {
        fontWeight: '600 ! important',
        fontSize: "18px",
        color: 'black',
        textAlign: "left",
        paddingLeft: '16px',
        // paddingTop: '20px',
    },
    programSubtitle: {
        fontSize: "14px",
        color: '  #585A64',
        fontWeight: '500',
        paddingTop: '6px',
        textAlign: "left",
        paddingLeft: '16px',
        // marginBottom:'60px !important'

    },
    cardRoot: {
        background: '#fff',
        borderRadius: 16,
        // boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        padding: '18px 18px 14px 18px',
        display: 'flex',
        flexDirection: 'row',
        height: '18vh',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        // minHeight: 180,
        '@media (max-width: 900px)': {
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '10px 6px',
            gap: 8,
        },
        '@media (min-width: 1200px) and (max-width: 1440px)': {
            fontSize: '16px',
            padding: '20px 12px',
            // minHeight: 160,
        },
        '@media (min-width: 1800px) and (max-width: 2000px)': {
            // fontSize: '16px',
            padding: '30px 20px',
            // minHeight: 180,
        },
    },
    leftSection: {
        // minWidth: 220,
        // flex: '0 0 220px',
        '@media (max-width: 900px)': {
            minWidth: 0,
            flex: 'unset',
        },
        textAlign: 'left',
    },
    studentName: {
        fontWeight: "500 !important",
        fontSize: 24,
        lineHeight: 1.2,
        marginBottom: 2,
        '@media (max-width: 900px)': {
            fontSize: 22,
        },
        '@media (min-width: 1200px) and (max-width: 1440px)': {
            fontSize: '18px',
        },
    },
    studentId: {
        fontWeight: "400 !important",
        fontSize: 16,
        color: '#6B7280',
        marginBottom: 12,
        '@media (min-width: 1200px) and (max-width: 1440px)': {
            fontSize: '14px',
        },
    },
    birthdayPill: {
        display: 'inline-flex',
        alignItems: 'center',
        border: '1.5px solid #3061FF',
        borderRadius: 24,
        padding: '2px 9px',
        fontSize: 14,
        fontWeight: 500,
        color: '#373A45',
        // background: '',
        // gap: 6,
        marginTop: 6,
        '@media (min-width: 1200px) and (max-width: 1440px)': {
            fontSize: '12px',
        },
    },
    rightSection: {
        flex: 1,
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: 18,
        '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 12,
        },
        '@media (max-width: 700px)': {
            gridTemplateColumns: '1fr',
            gap: 8,
        },
    },
    infoBox: {
        background: '#F7F9FC',
        borderRadius: 12,
        padding: '18px 20px',
        minWidth: 120,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        height: '100%',
        '@media (max-width: 900px)': {
            padding: '12px 10px',
        },
        '@media (min-width: 1200px) and (max-width: 1440px)': {
            padding: '16px 8px',
        },
    },
    label: {
        fontSize: 14,
        color: '#6B7280',
        fontWeight: 400,
        marginBottom: 2,
        '@media (min-width: 1200px) and (max-width: 1440px)': {
            fontSize: '12px',
        },
    },
    value: {
        fontSize: 18,
        fontWeight: "500 !important",
        color: '#222B45',
        lineHeight: 1.3,
        paddingTop: 10,
        marginBottom: 0,
        '@media (min-width: 1200px) and (max-width: 1440px)': {
            fontSize: '14px',
            fontWeight: "500 !important",
        },
    },
    attendanceBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    attendancePercent: {
        fontWeight: 600,
        color: '#3B5EFF',
        fontSize: 18,
        marginLeft: 4,
    },
    daysAttended: {
        fontWeight: 700,
        fontSize: 18,
        color: '#222B45',
        marginRight: 2,
    },
    daysTotal: {
        fontWeight: 400,
        fontSize: 14,
        color: '#6B7280',
    },
}));

const StudentProfileSummaryCard: React.FC = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { state: { user }, } = useContext(AuthContext);
    const userData: any = user as AuthUser;
    // Demo data (replace with props or context as needed)
    const [StudentData, setStudentData] = useState<any>(null);
    useEffect(() => {
        getStudentProfile(userData.ContactId)
            .then((data) => {
                console.log(data?.data?.studentDetails?.[0], "datatatata12321");
                setStudentData(data?.data);
            });
    }, []);
    const student = {
        name: StudentData?.studentDetails?.[0]?.Name,
        id: StudentData?.studentDetails?.[0]?.Registration_Number__c,
        birthday: StudentData?.studentDetails?.[0]?.Birthdate,
        grade: StudentData?.studentDetails?.[0]?.Primary_Academic_Program__r?.Name,
        advisor: StudentData?.studentDetails?.[0]?.Name,
        homeroom: StudentData?.studentDetails?.[0]?.Homeroom_Advisor__r?.Name,
        attendance: StudentData?.attendance,
        attended: StudentData?.attendedDays,
        totalDays: StudentData?.totalDays,
    };

    return (
        <Box className={classes.cardRoot}>
            {/* Left Section */}
            <Box className={classes.leftSection} style={{ minWidth: "170px" }}>
                <Typography className={classes.studentName}>{student.name}</Typography>
                <Typography mt={0.8} className={classes.studentId}>{student.id}</Typography>
                <Box mt={0.8} className={classes.birthdayPill}>
                    {/* <CakeIcon sx={{ fontSize: 18, color: '#F7A703', mr: 1 }} /> */}
                    🎂 {student.birthday}
                </Box>
            </Box>
            <Grid className={classes.dividerresact} />
            {/* Right Section */}
            <Box className={classes.rightSection}>
                <Box className={classes.infoBox}>
                    <Typography className={classes.label}>Grade</Typography>
                    <Typography className={classes.value}>{student.grade}</Typography>
                </Box>
                <Box className={classes.infoBox}>
                    <Typography className={classes.label}>Homeroom Advisor</Typography>
                    <Typography className={classes.value}>{student.advisor}</Typography>
                </Box>
                <Box className={classes.infoBox}>
                    <Typography className={classes.label}>Homeroom</Typography>
                    <Typography className={classes.value}>{student.homeroom}</Typography>
                </Box>
                <Box className={classes.infoBox}>
                    <Typography className={classes.label}>Attendance Percentage</Typography>
                    <Box className={classes.attendanceBox}>
                        <CircularProgress
                            variant="determinate"
                            value={student.attendance}
                            size={28}
                            thickness={5}
                            sx={{ color: '#3B5EFF', background: '#E6EDFF', borderRadius: '50%' }}
                        />
                        <Typography className={classes.attendancePercent}>{student.attendance}%</Typography>
                    </Box>
                </Box>
                <Box className={classes.infoBox}>
                    <Typography className={classes.label}>Total days attended</Typography>
                    <Typography>
                        <span className={classes.daysAttended}>{student.attended}</span>
                        <span className={classes.daysTotal}>/{student.totalDays} days</span>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const MyProfileStudent: React.FC = () => {
    const classes = useStyles();
    const { state: { user }, } = useContext(AuthContext);
    const userData = user as AuthUser;
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);
    const theme = useTheme();
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };
    const tabs = [
        { label: "My Path", value: 0, component: <MyPath /> },
        // { label: "Personal Details", value: 1, component: <PersonalDetails /> },
        // { label: "Education", value: 2, component: <Education /> },
        // { label: "Request & Complaints", value: 3, component: <RequestComplicants /> }
    ];
    const [studentInfo, setStudentInfo] = useState({
        fullName: "",
        Profile: "",
        Program: "",
        Id: ""
    });

    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [studentData, setStudentData] = useState<any>(null);
    useEffect(() => {
        getStudentProfile(userData.ContactId)
            .then((data) => {
                console.log(data?.data?.studentDetails?.[0], "datatatata12321");
                setStudentData(data?.data);
            });
        const userDetails = getUserDetails();
        if (userDetails?.ContactId) {
            getStudentInfo(userDetails.ContactId)
                .then((data) => {
                    setStudentInfo({
                        fullName: `${data?.firstName} ${data?.lastName}`,
                        Profile: data?.profile,
                        Program: data?.courseList,
                        Id: data?.registrationId
                    });
                })
                .catch(() => setError("Failed to load student details."))
                .finally(() => setLoading(false));
        }
    }, []);
    if (loading) return <KenLoader />;
    if (error) return <Typography color="error">{error}</Typography>;

    const Program = studentInfo.Program ? studentInfo.Program.charAt(0).toUpperCase() + studentInfo.Program.slice(1).toLowerCase() : '';

    return (
        <>
            <Grid className="p-2 bg-white" sx={{ borderRadius: "12px" }}>
                <Grid>
                    <StudentProfileSummaryCard />
                </Grid>
            </Grid>
            <Grid container >
                <Box sx={{
                    marginTop: 2,
                    backgroundColor: "white",
                    borderRadius: "12px",
                    padding: 2,
                    width: "100%",
                    height: 'calc(62.5vh)'
                }} >
                    <div>
                        <MyStudentTabPanel data={studentData} />
                        {/* <Tabs
                            value={activeTab}
                            onChange={handleTabChange}
                            textColor="inherit"

                            TabIndicatorProps={{ style: { backgroundColor: "#2C58E8", height: "2px" } }}
                        >
                            {tabs.map((tab) => (
                                <Tab
                                    key={tab.value}
                                    label={tab.label}
                                    value={tab.value}
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        textTransform: "none",
                                        color: "black",
                                        fontWeight: activeTab === tab.value ? 500 : "normal",
                                        fontSize: "16px",
                                        "&.Mui-selected": {
                                            color: "black",
                                        }
                                    }}
                                />
                            ))}
                        </Tabs>

                        <Grid className={classes.tabline} />

                        <Box mt={2} sx={{ height: '48vh !important' }} >
                            {tabs.find((tab) => tab.value === activeTab)?.component}
                        </Box> */}
                    </div>
                </Box>

            </Grid>
        </>
    )
};

export default MyProfileStudent;
